import _ from 'lodash'
import { ExportToCsv } from 'export-to-csv'
import { generateHash } from '../../../../common/utils'

const exportOptions = {
  fieldSeparator: ',',
  quoteStrings: '"',
  decimalSeparator: '.',
  showLabels: true,
  showTitle: false,
  useTextFile: false,
  useBom: true,
  useKeysAsHeaders: true,
}

const collectTranslates = ({ field, prefix, model, data, locales }) => {
  const item = _.get(model, field, {})
  if(!item.libraryID) {
    locales.forEach(locale => {
      data.push({
        field: `${prefix}.${field}.${locale.id}`,
        locale: locale.name,
        text: item[locale.id] || '',
      })
    })
  }
  return data
}


const collectRecipe = (model, data, locales) => {

  collectTranslates({
    field: 'values.title',
    prefix: 'recipeBunch',
    model, data, locales,
  })

  collectTranslates({
    field: 'values.description',
    prefix: 'recipeBunch',
    model, data, locales,
  })

  return data
}


const collectLevel = ({ level, variation, index, model, data, locales }) => {
  if(!variation[level].translates.defaultLabels) {
    for(let i = 0; i < 5; i++) {
      collectTranslates({
        field: `values[${index}].cooking.translates.level${i}`,
        prefix: 'recipe',
        model, data, locales,
      })
    }
  }
}

const collectIngredients = ({ variation, index, model, data, locales }) => {
  variation.sections.forEach((section, sectionIndex) => {
    collectTranslates({
      field: `values[${index}].sections[${sectionIndex}].title`,
      prefix: 'recipe',
      model, data, locales,
    })
    section.ingredients.forEach((ingredient, ingredientIndex) => {
      collectTranslates({
        field: `values[${index}].sections[${sectionIndex}].ingredients[${ingredientIndex}].additionalDescription`,
        prefix: 'recipe',
        model, data, locales,
      })
      if (ingredient.replacements && ingredient.replacements.length) {
        ingredient.replacements.forEach((replacement, replacementIndex) => {
          collectTranslates({
            field: `values[${index}].sections[${sectionIndex}].ingredients[${ingredientIndex}].replacements[${replacementIndex}].additionalDescription`,
            prefix: 'recipe',
            model, data, locales,
          })
        })
      }
    })
  })
}


const collectSteps = ({ variation, index, model, data, locales }) => {
  Reflect.ownKeys(variation.applianceSteps || {}).forEach(appliance => {
    const initialSteps = _.get(model, `values[${index}].applianceSteps.${appliance}.initialSteps`, [])
    initialSteps.forEach((step, stepIndex) => {
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.initialSteps[${stepIndex}].title`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.initialSteps[${stepIndex}].description`,
        prefix: 'recipe',
        model, data, locales,
      })
    })
    const cookingSteps = _.get(model, `values[${index}].applianceSteps.${appliance}.cookingSteps`, [])
    cookingSteps.forEach((step, stepIndex) => {
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.cookingSteps[${stepIndex}].title`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.cookingSteps[${stepIndex}].name`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.cookingSteps[${stepIndex}].description`,
        prefix: 'recipe',
        model, data, locales,
      })
    })
    const preparationSteps = _.get(model, `values[${index}].applianceSteps.${appliance}.preparationSteps`, [])
    preparationSteps.forEach((step, stepIndex) => {
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.preparationSteps[${stepIndex}].title`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.preparationSteps[${stepIndex}].description`,
        prefix: 'recipe',
        model, data, locales,
      })

      if(step.replacements && step.replacements.length) {

        step.replacements.forEach((replacement, replacementIndex) => {
          collectTranslates({
            field: `values[${index}].applianceSteps.${appliance}.preparationSteps[${stepIndex}].replacements[${replacementIndex}].title`,
            prefix: 'recipe',
            model, data, locales,
          })
          collectTranslates({
            field: `values[${index}].applianceSteps.${appliance}.preparationSteps[${stepIndex}].replacements[${replacementIndex}].description`,
            prefix: 'recipe',
            model, data, locales,
          })
        })
      }
    })
    const finalSteps = _.get(model, `values[${index}].applianceSteps.${appliance}.finalSteps`, [])
    finalSteps.forEach((step, stepIndex) => {
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.finalSteps[${stepIndex}].title`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.finalSteps[${stepIndex}].name`,
        prefix: 'recipe',
        model, data, locales,
      })
      collectTranslates({
        field: `values[${index}].applianceSteps.${appliance}.finalSteps[${stepIndex}].description`,
        prefix: 'recipe',
        model, data, locales,
      })
    })
  })
}

const collectRecipeVariations = (model, data, locales) => {

  model.values.forEach((variation, index) => {

    locales.forEach(locale => {
      data.push({
        field: `recipe.values[${index}].translates.${locale.id}.variant`,
        locale: locale.name,
        text: _.get(variation, `translates.${locale.id}.variant`, ''),
      })
    })

    collectLevel({ level: 'browning', variation, index, model, data, locales })
    collectLevel({ level: 'cooking', variation, index, model, data, locales })
    collectIngredients({ variation, index, model, data, locales })
    collectSteps({ variation, index, model, data, locales })
  })

  return data
}

export const collectAllTranslates = (recipeModel, variationsModel, locales) => {
  const data = []
  collectRecipe(recipeModel, data, locales)
  collectRecipeVariations(variationsModel, data, locales)
  data.push({
    field: 'PLEASE DON\'T CHANGE NEXT LINES!!!',
    locale: '!!!',
    text: '',
  })
  data.push({
    field: 'checksumBunch',
    locale: '!!!',
    text: generateHash(JSON.stringify(recipeModel.values)),
  })
  data.push({
    field: 'checksumRecipes',
    locale: '!!!',
    text: generateHash(JSON.stringify(variationsModel.values)),
  })
  return data
}

export default (recipeModel, variationsModel, locales) => {
  const csvExporter = new ExportToCsv(exportOptions)

  const data = collectAllTranslates(recipeModel, variationsModel, locales)
  const result = csvExporter.generateCsv(data, true)

  let blob = new Blob([result], { type: 'text/plain;charset=utf-8' })

  let url = window.URL.createObjectURL(blob)

  let link = document.createElement('a')
  link.download = `${recipeModel.values.name}.csv`
  link.href = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
